import { useEffect } from 'react';
import api from './api';

const useCSRF = () => {
    useEffect(() =>{
        api.get('/sanctum/csrf-cookie');
    },[]);
}

export default useCSRF;